import merchantAccountFields from '../../fields/merchantAccountFields';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import CONTRACT_ACCESS from '../apiUrls';
import { replaceParameters } from '../../../../../common-utils/functions/restUtils';

/**
 *
 * @param responseData response.data object
 * @param responseData.x25Centers array
 * @returns Mapped data object
 */
function mapResponseData(responseData) {
    const data = {};
    data[merchantAccountFields.X25_CENTERS.key] = responseData[merchantAccountFields.X25_CENTERS.key];
    return data;
}

const queryGetX25Centers = ({ application, bankCode }, enabled) => {
    return {
        queryKey: [CONTRACT_ACCESS.GET_X25_CENTERS.queryKey, application, bankCode],
        queryFn: async () => {
            const response = await client.get(replaceParameters(CONTRACT_ACCESS.GET_X25_CENTERS.url, { application: application, bankCode: bankCode }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetX25Centers;